import { Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
// import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';

// import Swiper from 'react-id-swiper';
import Carousel from 'nuka-carousel';

export interface TestimonialProps {
  data: {
    text: string;
    name: string;
    mode: string;
  }[];
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    '& .slider': {},
    '& .slider-frame': {
      paddingLeft: (isMobile) => (isMobile ? '15px !important' : '15px !important'),
    },
    '& .slider-slide': {
      // maxWidth: (isMobile) => (isMobile ? 'none' : 360),
    },
    '& .slider-control-bottomcenter': {
      display: (isMobile) => (isMobile ? 'block' : 'none'),
      bottom: '-32px !important',
      '& .paging-item button svg': {
        display: 'none',
      },
      '& .paging-item': {
        marginLeft: 6,
      },
      '& .paging-item button': {
        width: '10px',
        height: '10px',
        borderRadius: '100px',
        opacity: '1 !important',
        backgroundColor: `${theme.specialColors.CIRCULAR_PROGRESS}  !important`,
        padding: 0,
      },
      '& .paging-item.active button': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        width: '18px',
        borderRadius: '50px',
      },
    },
  },
  sliderBtnNext: {
    display: (isMobile) => (isMobile ? 'none' : 'block'),
    position: 'absolute',
    right: -20,
    top: '50%',
    transform: 'translate(-50%)',
    width: 23,
    height: 38,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    backgroundImage: 'url(./images/arrow.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    '&:focus': {
      outline: 'none',
    },
    '&:after': {
      display: 'none',
    },
  },
  sliderBtnPrev: {
    display: (isMobile) => (isMobile ? 'none' : 'block'),
    position: 'absolute',
    left: 10,
    top: '50%',
    width: 23,
    height: 38,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    backgroundImage: 'url(./images/arrow.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    transform: 'translate(-50%) rotate(180deg)',
    '&:focus': {
      outline: 'none',
    },
    '&:after': {
      display: 'none',
    },
  },
  slideWrapper: {},
  slide: {
    padding: '20px 0',
  },
  slideInnerWrapper: {
    maxWidth: (isMobile) => (isMobile ? 'calc(100% - 32px)' : '314px'),
    borderRadius: 16,
    boxShadow: theme.shadows[3],
    padding: '32px 16px',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    fontSize: 16,
    lineHeight: '26px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 208,
    marginTop: 32,
  },
  text: {},
  nameBox: {
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  name: {
    fontWeight: 600,
  },
}));

export default function UserTestimonialsSlider(props: TestimonialProps) {
  const isMobile = useSelector((state: RootState) => state.common.platform.isMobile);
  const classes = useStyles(isMobile);

  return (
    <div className={classes.root}>
      <Carousel
        slidesToShow={isMobile ? 1 : 3}
        slideWidth={1}
        // cellSpacing={24}
        cellAlign="center"
        wrapAround
        easing="easeLinear"
        edgeEasing="easeLinear"
        transitionMode="scroll"
        speed={600}
        framePadding={isMobile ? '0 -17px' : '0 33px 0 45px'}
        // width="50%"
        renderCenterLeftControls={({ previousSlide }) => (
          <button
            aria-label="Previous"
            className={classes.sliderBtnPrev}
            type="button"
            onClick={previousSlide}
          />
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button
            aria-label="Next"
            className={classes.sliderBtnNext}
            type="button"
            onClick={nextSlide}
          />
        )}
      >
        {props.data.map((testimonial) => (
          <div key={testimonial.text} className={classes.slideWrapper}>
            <div className={classes.slide}>
              <div className={classes.slideInnerWrapper}>
                <img src="./images/theme/commonImages/quotes.png" alt="testimonial" height="40" />
                <div className={classes.content}>
                  <div className={classes.text}>{testimonial.text}</div>
                  <div className={classes.nameBox}>
                    <div className={classes.name}>{testimonial.name}</div>
                    <div> &nbsp; via {testimonial.mode}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
